module.exports = __webpack_public_path__ + "img/ArrowDown-icon.86e59085.svg";